import { styled, keyframes, Box, ColumnsV2, Flex, SpacingStack, StyleSystemProps } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FadeInWrapper = styled(Box)`
  animation: ${fadeIn} 1s linear;
`;

export const StyledColumnsContainer = styled(SpacingStack)``;
const styledColumnsContainerStyles: StyleSystemProps = {
  width: '100%',
  height: ['unset', pxToRem(628)]
};

export const StyledConfirmationContainer = styled(Flex)``;
const styledConfirmationContainerStyles = (hasCollectionMembers: boolean): StyleSystemProps => ({
  justifyContent: 'center',
  alignItems: 'center',
  paddingRight: hasCollectionMembers ? [0, 6] : 0,
  flex: ['unset', '1 1 50%']
});

export const StyledPhoto = styled.div<{ photoUrl?: string }>`
  width: 150px;
  height: 150px;
  background-image: ${({ photoUrl }) => `url(${photoUrl})`};
  border-radius: 50%;
  align-self: center;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), ${({ photoUrl }) => `url(${photoUrl})`};
  background-size: cover;
  position: relative;
`;

export const StyledDiv = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const StyledColumns = styled(ColumnsV2)`
  width: 100%;
`;

export const styles = {
  columnsContainerStyles: styledColumnsContainerStyles,
  confirmationContainerStyles: styledConfirmationContainerStyles
};
